var DateEnum;
(function (DateEnum) {
    DateEnum["tiFormat"] = "HHmmss";
    DateEnum["tiFormatP"] = "HH:mm:ss";
    DateEnum["ti4Format"] = "HHmm";
    DateEnum["ti4FormatP"] = "HH:mm";
    DateEnum["daFormat"] = "yyyyMMdd";
    DateEnum["daFormatP"] = "yyyy/MM/dd";
    DateEnum["twDaFormat"] = "yyyMMdd";
    DateEnum["twDaFormatP"] = "yyy/MM/dd";
    DateEnum["twDaFormatStr"] = "y/MM/dd";
    DateEnum["daTiFormat"] = "yyyyMMdd HHmmss";
    DateEnum["daTiFormatN"] = "yyyyMMddHHmmss";
    DateEnum["daTiFormatP"] = "yyyy/MM/dd HH:mm:ss";
    DateEnum["daTi4Format"] = "yyyyMMdd HHmm";
    DateEnum["daTi4FormatP"] = "yyyy/MM/dd HH:mm";
    DateEnum["dateTimeWithMillis"] = "YYYY-MM-DD HH:mm:ss.S";
})(DateEnum || (DateEnum = {}));
// #region format const
export var dDaFms = [DateEnum.daFormat, DateEnum.daFormatP];
export var dDaTi4s = [DateEnum.daTi4Format, DateEnum.daTi4FormatP];
// #endregion
export default DateEnum;
